import styled, {keyframes } from "styled-components";

export const Container = styled.div`
    min-height: 100vh;
    min-width: 100vw;
    background-color: ${props => props.color};
    position: relative;
    display: flex;
    justify-content: center;
    overflow: hidden;
    z-index: 11;
`

export const Card = styled.div`
    width: 90vw;
    bottom: 0;
    background-color: white;
    border-radius: 20px 20px 0px 0px;
    box-shadow: 0px -1px 18px -6px rgba(0,0,0,0.49);
    height: 55vh;
    position: absolute;
`

export const CardData = styled.div`
    height: calc(100% - 155px);
    overflow-y: scroll;
    margin: -5px 25px 18% 25px;
`

export const CardActions = styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;
    min-height: 18%;    

`

export const CardActionsButtons = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 20px;
    z-index: 100;
    background-color: white;
`   


export const BallImage = styled.img`
    position: absolute; 
    transform: scale(150%) translate(-2vw, 15vh);
    right: 0;
    top: 0;
    filter: invert(100%) opacity(30%);
    src: ${(props => props.src)};
`

export const PokeTipo = styled.img`
    transform: translate(5px, -10px);
`

export const PokeTitle = styled.div`
    position: absolute;
    left: 0;
    margin-top: 10%;
    margin-left: 5%;
`
const breatheAnimation = keyframes`

  0%{
    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    transform: translateX(-100px) rotate(-540deg) translate3d(0,0,0);
  }
  40%, 43% {
    transition-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    transform: translateX(65vw) rotate(0deg) translate3d(0, -30px, 0);
  }
  70% {
    transition-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    transform:translateX(65vw) rotate(0deg) translate3d(0, -15px, 0);
  }
  99%, 100% {
    transition-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    transform: translateX(65vw) rotate(0deg) translate3d(0,-4px,0)  scale(0);
    opacity: 0;
  }
`

const pokemonAnimation = keyframes`
    0% {
        opacity: 0;
    }
    49% {
        transform: scale(0);
    }
    50% {
        filter: blur(150px) contrast(0%) brightness(2) invert(0);
        transform: scale(0) translateY(-20%);
        opacity: 0;
    }
    80% {
        filter: blur(10px) contrast(0%) brightness(2) invert(0);
        opacity: 1;
    }
    100% {
        filter: blur(0px);
        opacity: 1;
    }
`
export const PokeIntro = styled.img`
    width: 50px;
    position: absolute;
    top: 0;
    left: 0;
    margin-top: 35vh;
    animation-name: ${breatheAnimation};
    animation-duration: 1.5s;
    animation-iteration-count: initial;
    animation-fill-mode: forwards;

`

export const PokeImage = styled.img`
    position: absolute; 
    width: 200px;
    transform: scale(1.1) translateY(-70%);
    top: 0;
    right: 0;
    animation-name: ${pokemonAnimation};
    animation-duration: 1s;
    animation-iteration-count: initial;
    z-index: 5000;
`

export const MiniContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    margin-top: -20px;
    height: 100%;
`

export const MiniCard = styled.div`
    width: 30vw;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
`

export const MiniBall= styled.img`
    width: 30vw;
    filter: invert(100%) opacity(30%);
    position: absolute;
`

export const MiniPoke = styled.img`
    padding-top: 20px;
    width: 25vw;
    filter: opacity(100%);
    top: 0;
    filter: ${props => props.capturado == "false" && "contrast(0%) brightness(50%)" };
`

export const CardImg = styled.img`
    width: 40vw;
    border-radius: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1), 0px 8px 16px rgba(0, 0, 0, 0.2), 0px 12px 24px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
        transform: translateY(-10px);
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2), 0px 16px 32px rgba(0, 0, 0, 0.3), 0px 24px 48px rgba(0, 0, 0, 0.25);
    }
`